import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateAccountComponent } from '../create-account/create-account.component';

@Component({
  selector: 's18-mobile-app',
  templateUrl: './mobile-app.component.html',
  styleUrls: ['./mobile-app.component.scss']
})
export class MobileAppComponent implements OnInit {

  constructor(
    private dialog : MatDialog
  ) { }

  ngOnInit() {
  }

  startNow(){
    window.open("https://app.golfgameskeeper.com");
  }

}
